<discovery-collection-status
  [data]="data"
  [innerContent]="innerContent"
  (previousNextStatusEventEmitter)="previousNextStatusEvent($event)"
></discovery-collection-status>
